import React, { useState, useEffect, useContext } from "react";
import {
  Card,
  Typography,
  Spin,
  Alert,
  Row,
  Col,
  Button,
} from "antd";
import {
  FileTextOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import MDEditor from "@uiw/react-md-editor";
import { FirebaseContext } from "../context/FirebaseContext";
import { PromptsService, Prompt } from "../services/PromptsService";

const { Title, Text } = Typography;
interface PromptsManagerProps {}

const PromptsManager: React.FC<PromptsManagerProps> = () => {
  const firebase = useContext(FirebaseContext);
  const [prompts, setPrompts] = useState<Prompt[]>([]);
  const [loading, setLoading] = useState(true);
  const [promptsService] = useState(
    () => new PromptsService(firebase.functions)
  );

  const loadPrompts = async () => {
    try {
      setLoading(true);
      const response = await promptsService.getPrompts();
      if (response.success && response.data) {
        setPrompts(response.data);
      } else {
        console.error("Error al cargar los prompts:", response.error);
        setPrompts([]);
      }
    } catch (error) {
      console.error("Error al cargar los prompts:", error);
      setPrompts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPrompts();
  }, []);

  if (loading) {
    return (
      <Card>
        <div style={{ textAlign: "center", padding: "40px" }}>
          <Spin size="large" tip="Cargando prompts..." />
        </div>
      </Card>
    );
  }

  const promptsList = prompts;

  return (
    <div>
      <Card
        title={
          <div style={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "space-between",
            width: "100%"
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FileTextOutlined />
              <span>Vista de Prompts</span>
            </div>
            <Button
              type="primary"
              icon={<LinkOutlined />}
              onClick={() => window.open('https://console.firebase.google.com/project/atm-ai-rq-generator-p-202/config/env/firebase-server', '_blank')}
            >
              Actualizar Prompts
            </Button>
          </div>
        }
      >
        <div style={{ marginBottom: "16px" }}>
          <Text type="secondary">
            Visualiza los prompts de Markdown almacenados en Firebase Remote
            Config. Estos prompts se utilizan para configurar el comportamiento
            de la IA. Se pueden editar los prompts desde la consola de Firebase, puede acceder
            a la consola seleccionando la opción de "Actualizar Prompts"
          </Text>
        </div>
      </Card>

      {promptsList.length === 0 ? (
        <Card style={{ marginTop: "16px" }}>
          <Alert
            message="No hay prompts configurados"
            description="Los prompts son creados y gestionados desde el backend"
            type="info"
            showIcon
          />
        </Card>
      ) : (
        <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
          {promptsList.map((prompt) => (
            <Col span={24} key={prompt.key}>
              <Card
                title={<Title level={5}>{prompt.key}</Title>}
              >
                <div
                  style={{
                    minHeight: "400px",
                    maxHeight: "600px",
                    overflow: "auto",
                    border: "1px solid #f0f0f0",
                    borderRadius: "6px",
                    padding: "16px",
                    backgroundColor: "#fafafa",
                  }}
                >
                  <MDEditor.Markdown
                    source={prompt.value}
                    style={{ backgroundColor: "transparent" }}
                  />
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default PromptsManager;
